import { useMemo } from 'react';
import type { DocumentUpload } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DocumentsApi } from 'api';
import { BANK_DOCUMENTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';
import { getObjectMap } from 'util/objectUtils';

export function useBankDocuments({ shouldNotifyOnChange = true }: { shouldNotifyOnChange?: boolean } = {}) {
  const documentsApi = new DocumentsApi();
  const { userBankId } = useUser();

  const { data: bankDocumentsData, isLoading: isLoadingBankDocuments } = useQuery({
    enabled: !!userBankId,
    queryKey: [BANK_DOCUMENTS_KEY, userBankId],
    queryFn: () => documentsApi.getDocuments(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  const { bankDocumentsMap } = useMemo(() => {
    if (!bankDocumentsData) return { bankDocumentMap: {} };

    const bankDocumentsMap: { [id: string]: DocumentUpload } = getObjectMap(bankDocumentsData, 'id');

    return { bankDocumentsMap };
  }, [bankDocumentsData]);

  return { bankDocumentsData, bankDocumentsMap, isLoadingBankDocuments };
}
